import { useState } from 'react'

const faqItems = [
  {
    question: 'What does a reinsurance broker do?',
    answer: 'A reinsurance broker advises insurers on programme design, prepares underwriting information, approaches suitable markets, negotiates terms and supports documentation, renewals and claims coordination.',
  },
  {
    question: 'Who can appoint WillMars Reinsurance Brokers?',
    answer: 'Our principal clients are insurers and reinsurers. We also provide risk and insurance advisory support to corporates, brokers and other professional stakeholders where the assignment falls within the applicable regulatory framework.',
  },
  {
    question: 'What is the difference between facultative and treaty reinsurance?',
    answer: 'Facultative reinsurance covers an individual risk and requires separate acceptance by the reinsurer. Treaty reinsurance covers an agreed portfolio or class of business under a standing contract.',
  },
  {
    question: 'How does WillMars design a reinsurance programme?',
    answer: 'We review the portfolio, loss experience, accumulation, capital objectives, risk appetite and current protection. We then recommend an appropriate structure, retention and placement strategy.',
  },
  {
    question: 'Can WillMars place large or complex risks?',
    answer: 'Yes. We arrange facultative support for energy, infrastructure, engineering, marine, aviation, liability, financial lines, terrorism, medical malpractice and other specialised exposures.',
  },
  {
    question: 'How does WillMars select reinsurance markets?',
    answer: 'Market selection considers financial strength, underwriting appetite, technical capability, capacity, service record, claims responsiveness and applicable regulatory requirements.',
  },
  {
    question: 'Does WillMars support claims?',
    answer: 'Yes. We assist with notification, documentation, coordination with insurers, reinsurers, loss adjusters and surveyors, and follow-up towards timely resolution.',
  },
  {
    question: 'Can WillMars help with catastrophe exposure analysis?',
    answer: 'Yes. We support portfolio review, exposure assessment, reinsurance statistics and catastrophe accumulation analysis to improve programme structure and market presentation.',
  },
  {
    question: 'Does WillMars provide training and technical consulting?',
    answer: 'Yes. We offer general and tailored training, reinsurance audits, programme-system support, user acceptance testing, policy development and advisory services.',
  },
  {
    question: 'Does WillMars arrange retrocession?',
    answer: 'Yes. We help reinsurers structure and place retrocession programmes to manage their own portfolio exposure.',
  },
  {
    question: 'Which markets does WillMars serve?',
    answer: 'We operate through offices in Kenya and Tanzania, serve clients across East Africa and neighbouring African markets, and connect assignments with international reinsurance markets through our wider professional network.',
  },
]

const previewCount = 4

function FAQ() {
  const [openIndex, setOpenIndex] = useState(0)
  const [showAll, setShowAll] = useState(false)
  const visibleItems = showAll ? faqItems : faqItems.slice(0, previewCount)

  function toggleItem(index) {
    setOpenIndex((current) => (current === index ? null : index))
  }

  function toggleList() {
    if (showAll) {
      setOpenIndex((open) => (open != null && open >= previewCount ? null : open))
    }
    setShowAll((current) => !current)
  }

  return (
    <section className="faq" id="faq">
      <div className="wrap">
        <div className="section-head">
          <div className="eyebrow">Frequently asked questions</div>
          <h2>
            <span className="intro-title-line">Reinsurance</span>
            <span className="intro-title-line">questions, answered.</span>
          </h2>
          <p>Clear, practical guidance on programme design, placements, market selection and claims support.</p>
        </div>
        <div className="faq-list">
          {visibleItems.map((item, index) => (
            <details
              key={item.question}
              name="willmars-faq"
              open={openIndex === index}
            >
              <summary
                onClick={(event) => {
                  event.preventDefault()
                  toggleItem(index)
                }}
              >
                {item.question}
              </summary>
              <p>{item.answer}</p>
            </details>
          ))}
        </div>
        <button
          className="btn faq-more"
          type="button"
          aria-expanded={showAll}
          onClick={toggleList}
        >
          {showAll ? 'Show fewer questions' : 'View all questions'}
        </button>
      </div>
    </section>
  )
}

export default FAQ
